import { MdKeyboardArrowRight } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import {
  academyPath,
  landingPath,
  learningToolsPath,
  qiraatPath,
  quranPath,
} from "../../components/routes/path";
import AffliateBoard from "./AffliateBoard";
import MainContent from "./MainContent";
import { cardInfos } from "../../components/Data/datas";

const AffiliatePage = () => {
  const { single_id } = useParams();
const result = single_id ? cardInfos[single_id - 1] : null;

  return (
    <div className="bg-[#F7F7F7] ">
      <div className="flex items-center p-4">
        <Link to={landingPath} className="hover:text-[#66B2FF]">
          <p className="text-sm sm:text-lg">Home</p>
        </Link>
        <MdKeyboardArrowRight className="mt-1" />
        <Link to={academyPath} className="hover:text-[#66B2FF]">
          <p className="text-sm sm:text-lg">Academy</p>
        </Link>
        <MdKeyboardArrowRight className="mt-1" />
        <Link
          to={
            result.bookCaterory == "QUR'AN"
              ? quranPath
              : result.bookCaterory == "Learning Tools"
              ? learningToolsPath
              : result.bookCaterory == "Key Principles of Qira’at" && qiraatPath
          }
          className="hover:text-[#66B2FF]"
        >
          <p className="text-sm sm:text-lg">{result.bookCaterory}</p>
        </Link>
        <MdKeyboardArrowRight className="mt-1" />
        <p className="text-sm sm:text-lg">{result.bookTitle}</p>
      </div>
      <AffliateBoard
        lessonNumber={result.lessonNumber}
        bookStudent={result.bookStudent}
        bookCaterory={result.bookCaterory}
        bookTitle={result.bookTitle}
        ratings={result.ratings}
        toCategory={
          result.bookCaterory == "QUR'AN"
            ? quranPath
            : result.bookCaterory == "Learning Tools"
            ? learningToolsPath
            : result.bookCaterory == "Key Principles of Qira’at" && qiraatPath
        }
      />
      <MainContent
        lessonNumber={result.lessonNumber}
        bookImage={result.bookImage}
        ratings={result.ratings}
        curriculumId={result.id}
      />
    </div>
  );
};

export default AffiliatePage;
